import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./_store";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "font-awesome/css/font-awesome.css";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import PrimeVue from "primevue/config";
import ToastService from "primevue/toastservice";
import "./assets/css/primevue/theme.css";
import "./assets/css/primevue/primeicons.css";
import "./assets/css/primevue/primevue.css";
import "./assets/css/colors.css";
import "./assets/css/style.css";
import "./assets/css/vars.css";
import "./assets/css/toggle/style.css";
import "./assets/css/splitter/style.css";
import "./assets/css/buttons/close.css";
import "./assets/css/general/style.css";
import "./assets/css/sideBars/sideBarLeft/style.css";
import "./components/dataModel/uploadFile/style.css";
import "./components/analytics/style.css";
import axios from "axios";
import VeeValidate from "vee-validate";
import Vuetify from "vuetify";
import "bootstrap-vue/dist/bootstrap-vue.css";
import IdleVue from "idle-vue";
import { createProvider } from "./_services/vue-apollo";
import {
  applyPolyfills,
  defineCustomElements
} from "@aws-amplify/ui-components/loader";

import "core-js/stable"; // only stable feature also is possible with only `core-js`
import "regenerator-runtime/runtime"; // To ensure that regeneratorRuntime is defined globally

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 60000 * 60, // 15 minutes
  startAtIdle: false
});

// import excel from 'vue-excel-export'
// import 'vuetify/dist/vuetify.min.css' // Ensure you are using css-loader
Vue.use(PrimeVue);
Vue.use(ToastService);
Vue.use(Vuetify);
Vue.use(VeeValidate);
// Vue.use(excel)
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.prototype.$http = axios;

Vue.config.productionTip = false;

//Amplify.configure(aws_exports);
applyPolyfills().then(() => {
  defineCustomElements(window);
});

new Vue({
  vuetify: new Vuetify(),
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount("#app");
